import { createFileRoute } from '@tanstack/react-router';
import { AdminPaymentsPage } from '@/features/admin-payments';

export const Route = createFileRoute('/_authenticated/_admin/admin-payments')({
  component: AdminPaymentsPage,
});
